<template>
    <main>
        <img src="https://referon.it/files/logo_big.png" alt="">
        <div id="card">
            <el-form label-position="top">
                <el-form-item label="Username">
                    <el-input v-model="username" />
                </el-form-item>

                <el-form-item label="Password">
                    <el-input v-model="password" show-password/>
                </el-form-item>

                <el-form-item>
                    <el-button style="width: 100%;" type="primary" @click="login">Accedi</el-button>
                </el-form-item>
            </el-form>
        </div>
    </main>
</template>

<script lang="ts">
import VueBase from "@/components/VueBase";
import AuthService from "@/services/AuthService";

export default class LoginView extends VueBase {
    username: string = "";
    password: string = "";

    async login() {
        try {
            const admin = await AuthService.login(this.username, this.password);
            sessionStorage.setItem("access-token", btoa(`${this.username}:${this.password}`));

            if (admin.role === "SUPER")
                this.$router.push("/");
            else
                this.$router.push("users");
        } catch (error) {

        }
    }
}
</script>

<style lang="scss" scoped>
main {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    row-gap: 30px;
    height: 100%;
}

#card {
    background-color: rgba(94, 88, 156, 0.2);
    border-radius: 10px;
    padding: 1em;
    width: 300px;
    border: 1px solid rgba(94, 88, 156, 0.5);
}
</style>